import Viewport from './Viewport'

export default {
  install(Vue) {
    Vue.component('impress-viewport', Viewport)
  },
}



// WEBPACK FOOTER //
// ./src/components/plugin/impress/index.js